import { TRANSLATION } from 'config/api-routes';
import { ResourceLanguage } from 'i18next';
import { GET } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

import { Locale } from '../config';

export default class TranslationService {
  async getAllTranslations(opts = {}) {
    const response = await GET(TRANSLATION.ALL.GET(), opts);

    return formatResponse(response) as {
      hasUpdates: boolean;
      translationsMap: Record<Locale, ResourceLanguage>;
    };
  }
}
